import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import HybridWebView from './hybridWebView/HybridWebView';
import NativeInterop from './implementation/NativeInterop';

import WebInterop from './implementation/WebInterop';
import Interop from './interfaces/Interop';
import BootComponent from './BootComponent';

/**Stream Chat API Key, Required for connecting to Stream Chat services*/
const apiKey = process.env.REACT_APP_STREAM_KEY || "";

/**Initialize the correct interop implementation based on environment*/
let interop: Interop;

if(HybridWebView.IsWebView()) {
    // Running inside a native mobile app (iOS or Android WebView)
    interop = new NativeInterop();
}
else {
  // Running in a regular web browser
  interop = new WebInterop();
}

/**
 * setTextSize - Global function for dynamic text scaling
 * CALLED BY: Native mobile app or parent window
 * PURPOSE: Allow user to adjust text size for accessibility
 */
(window as any).setTextSize = (size: Number) => {
  document.documentElement.style.setProperty('--text-size', `${size}%`);
};

const target_origin = process.env.REACT_APP_TARGET_ORIGIN!;

const container = document.getElementById('root');
let root = ReactDOM.createRoot(container!);

/**
 * Global function to completely reload the React app 
 * CALLED BY: Native mobile app when user changes events or needs fresh start
 * DIFFERENCE FROM BROWSER REFRESH:
 * - Browser refresh: Reloads entire page, loses all JS state
 * - reloadReactApp: Only resets React, preserves global JS state
 */
(window as any).reloadReactApp = function reloadApp() {
    root.unmount(); // Unmount the current tree (cleanup all components)
    root = ReactDOM.createRoot(container!); // Create new root (fresh React instance)
    root.render(<Index />); // Re-render from scratch (all state reset)
};

function Index() {
  return (
    <React.StrictMode>
        <BootComponent
          apiKey={apiKey}
          targetOrigin={target_origin}
          interop={interop}
          onRemount={() => (window as any).reloadReactApp()}
        />
    </React.StrictMode>
  );
}

root.render(<Index />);